__turbopack_context__.v({
  "active": "JVvqQa_active",
  "backButton": "JVvqQa_backButton",
  "header": "JVvqQa_header",
  "item": "JVvqQa_item",
  "link": "JVvqQa_link",
  "list": "JVvqQa_list",
  "menu": "JVvqQa_menu",
  "text": "JVvqQa_text",
  "textOnly": "JVvqQa_textOnly",
  "title": "JVvqQa_title",
  "titleLink": "JVvqQa_titleLink",
});
